export const dndAreaViewTexts = {
  dropHereMessage: 'ここにファイルをドロップしてください',
  dropFileMessage: 'ファイルをドロップして学習データの追加を行う',
  availableFileTypeMessage: 'ZIP, PDF, PNGファイルを利用できます'
} as const;
